import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import { useToast } from "../../contexts/ToastContext";


import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function SubCategoriesViewModel(logout) {
  const { showSuccess } = useToast();
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [subCategories, setSubCategories] = useState({
    data: [],
  });

  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getSubCategories = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`products/subcategories`, payload);
    setLoading(false);
    if (callResult.success) {
      setSubCategories(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch sub categories");
    }
  };

  return {
    emptyModal,
    setEmptyModelOpen,
    getSubCategories,
    loading,
    subCategories,
    setSlideOver,
    slideOver,
  };
}
